import { Loader2 } from 'lucide-react';

import { CALENDAR_HOUR_HEIGHT } from './constants';

// Analysing takes tens of seconds on a busy day, and a button that only says
// "Analysing…" leaves the CFO watching an unchanged page wondering whether they
// actually pressed it. The grid it is about to fill is drawn empty underneath,
// so the wait happens in the shape of the answer rather than in place of it.
export function AnalysisProgress() {
  return (
    <div className="relative" aria-busy>
      <div className="flex items-center gap-3 rounded-12 border border-border-faint bg-[var(--color-canvas-base)] px-4 py-3">
        <Loader2 className="size-4 shrink-0 animate-spin text-primary" />
        <div>
          <p className="text-sm font-medium text-text-primary">Reconstructing your day</p>
          <p className="text-xs text-text-tertiary">
            Reading ClickUp, your calendar and Slack, then grouping what they show. This can take a
            minute.
          </p>
        </div>
      </div>

      <div aria-hidden className="mt-3 flex gap-2 pr-1">
        <div className="w-14 shrink-0" />
        <div className="relative flex-1 border-l border-border-faint">
          {[0, 1, 2, 3, 4, 5].map((band) => (
            <div
              key={band}
              className="absolute inset-x-0 border-t border-border-faint"
              style={{ top: `${band * CALENDAR_HOUR_HEIGHT}px` }}
            />
          ))}
          {[
            { top: 0.5, height: 1 },
            { top: 2, height: 0.5 },
            { top: 3.25, height: 1.5 },
          ].map((ghost) => (
            <div
              key={ghost.top}
              className="absolute inset-x-0 animate-pulse rounded-8 bg-muted pr-2"
              style={{
                top: `${ghost.top * CALENDAR_HOUR_HEIGHT}px`,
                height: `${ghost.height * CALENDAR_HOUR_HEIGHT}px`,
              }}
            />
          ))}
          <div style={{ height: `${6 * CALENDAR_HOUR_HEIGHT}px` }} />
        </div>
      </div>
    </div>
  );
}
